<template>
  <div>
    <v-card flat class="blueCard"
      ><v-card-title
        class="d-flex flex-row flex-wrap align-start justify-center"
      >
        <div class="d-flex flex-row align-start">
          <div style="width: 100px">
            <v-img
              src="https://www.eyedock.com/images/menu_icons/samfap_icon.svg"
              contain
              max-height="80"
            />
          </div>

          <div>
            <div class="title">The GP SAM/FAP-er</div>
            <div>
              <div class="caption">
                Change base curves and apply overrefractions to GP lenses.
              </div>
              <!-- <a href="/documentation/oblique-cross-cyls" class="caption"
                >Calculator Documentation

                <v-icon x-small color="primary" class="mx-1"
                  >mdi-open-in-new</v-icon
                ></a
              > -->
            </div>
          </div>
        </div>
        <v-spacer class=""></v-spacer>
        <!-- <div class="caption text-sm-right my-2">
          Round results to
          <v-btn-toggle
            v-model="round"
            rounded
            mandatory
            dense
            class="toggleBtns mx-2"
            active-class="orangeActive"
          >
            <v-btn small :value="0.01">0.01</v-btn>
            <v-btn small :value="0.125">0.125</v-btn>
            <v-btn small :value="0.25">0.25</v-btn>
          </v-btn-toggle>
        </div> -->

        <!-- <v-btn
          small
          rounded
          depressed
          color="#FFF"
          class="mx-1 my-2"
          @click="clearForm =1"
          >Clear Form</v-btn
        > -->
      </v-card-title></v-card
    >
    <div class="d-flex flex-row flex-wrap my-4 mx-sm-4">
      <div v-for="eye in ['od', 'os']" :key="eye" class="mb-2 mr-4">
        <samfap-eye :eye="eye" :round="round" class="eyeCard" />
      </div>
    </div>

    <v-card class="pa-4 mx-sm-4" flat color="#fffcdc">
      <v-card-title> What's a SAM/FAP? </v-card-title>
      <v-card-text>
        <div class="d-flex flex-row my-3">
          <v-img
            src="https://www.eyedock.com/images/menu_icons/sam_icon.svg"
            contain
            width="80"
          />
          <div class="ml-2">
            <b>SAM (Steep Add Minus)</b>: When the base curve of the GP lens is
            <i>steepened</i> (i.e., the lens has a tighter fit) it creates a
            <b>plus</b> power effect. To compensate for this plus power and
            maintain the desired refractive correction, <b>minus</b> power is
            added to the lens prescription.
          </div>
        </div>
        <div class="d-flex flex-row">
          <v-img
            src="https://www.eyedock.com/images/menu_icons/fap_icon.svg"
            contain
            width="80"
          />
          <div class="ml-2">
            <b>FAP (Flat Add Plus)</b>: When the base curve of the GP lens is
            <i>flattened</i> (i.e., the lens has a looser fit) it creates a
            <b>minus</b> power effect. To counteract this minus power and
            maintain the refractive correction, <b>plus</b> power is added to
            the lens prescription.
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SamfapEye from "@/components/calcsStuff/SamfapEye";

export default {
  name: "Samfap",
  props: {},
  components: { SamfapEye },
  data: function () {
    return {
      round: 0.25,
    };
  },
  methods: {},
  computed: {},
  metaInfo() {
    return {
      title: "EyeDock/Calcs | SAMFAP",
    };
  },
};
</script>

<style scoped>
.eyeCard {
  max-width: 500px;
  min-width: 300px;
}
</style>
